const string2Object = variable => `typeof ${variable} === 'string' ? JSON.parse(${variable}) : ${variable}`;
const object2String = variable => `JSON.stringify(${variable})`;
const string2Number = variable => `Number(${variable})`;
const number2String = variable => `String(${variable})`;
const string2Array = (variable, separator) => `(${variable}?(${variable}).split('${separator}'):[])`;
const array2String = (variable, separator) => `(${variable} || []).join('${separator}')`;
export const transformMap = {
  'string-object': {
    getter: string2Object,
    setter: object2String
  },
  'object-string': {
    getter: object2String,
    setter: string2Object
  },
  'string-number': {
    getter: string2Number,
    setter: number2String
  },
  'number-string': {
    getter: number2String,
    setter: string2Number
  },
  'string-array': {
    getter: string2Array,
    setter: array2String
  },
  'array-string': {
    getter: array2String,
    setter: string2Array
  }
};